import { useLocale } from '../../libs/i18n';
import { CalendarNavigationAction } from './types';
export function useCalendar(props, state) {
    var readOnly = props.readOnly, disabled = props.disabled;
    var mode = state.mode, focusedDate = state.focusedDate, focusCalendar = state.focusCalendar, focusDate = state.focusDate, moveDate = state.moveDate;
    var isRTL = useLocale().isRTL;
    var onFocus = function () {
        focusCalendar(true);
    };
    var onBlur = function (event) {
        var relatedTarget = event.relatedTarget, currentTarget = event.currentTarget;
        if (!currentTarget.contains(relatedTarget)) {
            focusCalendar(false);
        }
    };
    var onKeyDown = function (event) {
        var action = null;
        switch (event.key) {
            case 'ArrowLeft':
                action = isRTL ? CalendarNavigationAction.NextCell : CalendarNavigationAction.PrevCell;
                break;
            case 'ArrowRight':
                action = isRTL ? CalendarNavigationAction.PrevCell : CalendarNavigationAction.NextCell;
                break;
            case 'ArrowUp':
                action = CalendarNavigationAction.UpperCell;
                break;
            case 'ArrowDown':
                action = CalendarNavigationAction.LowerCell;
                break;
            case 'Home':
                action = event.shiftKey
                    ? CalendarNavigationAction.FirstCell
                    : CalendarNavigationAction.StartCell;
                break;
            case 'End':
                action = event.shiftKey
                    ? CalendarNavigationAction.LastCell
                    : CalendarNavigationAction.EndCell;
                break;
            case 'PageUp':
                action = event.shiftKey
                    ? CalendarNavigationAction.PrevExtraView
                    : CalendarNavigationAction.PrevView;
                break;
            case 'PageDown':
                action = event.shiftKey
                    ? CalendarNavigationAction.NextExtraView
                    : CalendarNavigationAction.NextView;
                break;
        }
        if (action !== null) {
            event.preventDefault();
            focusDate(moveDate(focusedDate, action));
        }
    };
    var gridProps = {
        role: 'grid',
        'aria-readonly': readOnly,
        'aria-disabled': disabled,
        'aria-multiselectable': mode === 'multiple' || mode === 'range',
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
    };
    return {
        gridProps: gridProps,
    };
}
